import { fnFadeIn, fnFadeOut } from '../../../vendor/baseFunctions/baseFunctions'

const nodeMainAccordion = document.querySelectorAll('.accordion-home-main__col')
if (nodeMainAccordion.length && window.innerWidth > 991) {
	nodeMainAccordion.forEach(item => {
		item.addEventListener('mouseover', () => {
			if (!item.classList.contains('accordion-home-main__col_active')) {
				document.querySelector('.accordion-home-main__col_active').classList.remove('accordion-home-main__col_active')
				item.classList.add('accordion-home-main__col_active')
			}
		})
	})
}

const infoBtn = document.querySelector('.home-main__title-icon')
const info = document.querySelector('.home-main__title-info')
if (info) {
	infoBtn.addEventListener('click', () => {
		if (window.getComputedStyle(info).display === 'block') {
			fnFadeOut(info, 300)
		} else {
			fnFadeIn(info, 300)
		}
	})

	document.addEventListener("click", (e) => {
		const target = e.target
		const isInfo = target === info || info.contains(target)
		const isInfoBtn = target === infoBtn || infoBtn.contains(target)

		if (!isInfoBtn && !isInfo && window.getComputedStyle(info).display === 'block') {
			fnFadeOut(info, 300)
		}
	})
}

